import { styled } from '@ngw6/us-components';

export const StyledTrimModuleOfferTypeContainer = styled.div<any>`
${ ({offerStyle}) => `
    background: ${offerStyle.background};
    color: ${offerStyle.color};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 24px;
`}`;
